import React from 'react';

import { Image } from 'expo-image';
import { StyleSheet } from 'react-native';

import { ActionButtonVariants } from 'components/action-button';
import { LayoutContainer } from 'components/layout/styled';
import { routes } from 'navigation/routing';
import { t } from 'state/intl/translations';

import {
  ImageContainer,
  NotAvailableContainer,
  SectionTitle,
  StyledActionButtonLink,
} from './loyalty-not-available-at-delivery-mode.styled';

const localImage = require('assets/images/loyalty/White.svg');
const styles = StyleSheet.create({
  image: { width: '100%', height: '100%' },
});

const LoyaltyNotAvailableAtDeliveryMode: React.FC<React.PropsWithChildren<unknown>> = () => {
  const title = t('loyaltyNotAvailableAtDeliveryModeTitle');
  const firstRedirectPath = routes.storeLocator;
  const firstButtonText = t('loyaltyNotAvailableAtDeliveryModePrimaryCta');

  return (
    <LayoutContainer>
      <NotAvailableContainer>
        <ImageContainer>
          <Image
            source={localImage}
            accessibilityLabel="A cartoon woman with cucumbers over her eyes"
            contentFit="contain"
            style={styles.image}
          />
        </ImageContainer>
        <SectionTitle variant="headerOne">{title}</SectionTitle>
        <StyledActionButtonLink variant={ActionButtonVariants.OUTLINE} to={firstRedirectPath}>
          {firstButtonText}
        </StyledActionButtonLink>
      </NotAvailableContainer>
    </LayoutContainer>
  );
};

export default LoyaltyNotAvailableAtDeliveryMode;
